import React from "react"

import type { ReducedIconsContainer } from "types/cms"

import {
  gridCopy,
  iconsGrid,
  iconFlex,
  paddingLeft,
} from "./IconsContainer.css"

type Props = {
  iconContainer: ReducedIconsContainer
}

export const IconsContainer: React.FC<Props> = ({ iconContainer }) => {
  const { icons } = iconContainer
  return (
    <div>
      <p className={gridCopy}>{iconContainer.title}</p>
      <div className={iconsGrid}>
        {icons &&
          icons.length > 0 &&
          icons.map((icon, i) => {
            const { icon: parsedIcon } = icon
            const flexClass =
              i % 2 === 0 ? iconFlex : `${iconFlex} ${paddingLeft}`
            return (
              <div key={icon.label} className={flexClass}>
                <div
                  style={{
                    WebkitMask: `url(${parsedIcon.src}) no-repeat center`,
                    mask: `url(${parsedIcon.src}) no-repeat center`,
                  }}
                />
                <p>{icon.label}</p>
              </div>
            )
          })}
      </div>
    </div>
  )
}
